import React, { useEffect, useState } from 'react';
import { ScrollView } from 'react-native';

import { Box, Inline } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';

import analytics from '../../../../modules/analytics';
import HeaderServiceButton from './HeaderServiceButton';
import './HeaderServices.module.scss';
import { ProviderServiceGroup } from '../../../../api/Providers/ServiceGroups';
import { scrollToElement } from '../../../../utils/scrollToElement';

type StickyServiceGroupTilesProps = {
  serviceGroups: ProviderServiceGroup[];
  onShowAllServices: () => void;
  isServiceListExpanded: boolean;
};

const StickyServiceGroupTiles = ({
  serviceGroups,
  onShowAllServices,
  isServiceListExpanded,
}: StickyServiceGroupTilesProps) => {
  const [scrollTop, setScrollTop] = useState<number>(0);
  const [shouldBeGrey, setShouldBeGrey] = useState<boolean>(false);

  const handleCategoryClick = (category: string) => {
    analytics.track('click', {
      component: 'StickyServiceGroupTiles',
      tile_clicked: category,
    });

    scrollToElement(`[data-testid="service-group-${category?.toLowerCase?.()}"]`, '[data-testid="Profile-content"]', 220);
    if (!isServiceListExpanded) {
      onShowAllServices();
    }
  };
  // track the scroll position of the whole page to decide
  // if the menu's background should be beige or gray.
  // When it's sticky, it should be gray, otherwise, beige.
  const handleStickyBarScroll = event => setScrollTop((event.target as any).scrollTop);
  useEffect(() => {
    const parentElement = document.querySelector('[data-testid="Profile-content"]');
    parentElement.addEventListener('scroll', evt => handleStickyBarScroll(evt));
    return parentElement.removeEventListener('scroll', evt => handleStickyBarScroll(evt));
  }, []);

  useEffect(() => {
    if (scrollTop >= 713) {
      setShouldBeGrey(true);
    } else {
      setShouldBeGrey(false);
    }
  }, [scrollTop]);

  return (
    <Box
      minHeight={64}
      minWidth="100%"
      color={shouldBeGrey ? BrandColor.SuperLight : BrandColor.BoneLight}
      styleName="sticky-service-tiles"
      testID="sticky-parent"
    >
      <Box
        justifyContent="flex-start"
        testID="profile-service-group-tiles"
      >
        <Inline
          space={4}
          paddingX={16}
          alignItems="center"
        >
          <ScrollView horizontal>
            <Inline
              space={8}
              paddingTop={24}
              paddingBottom={24}
            >
              {serviceGroups.filter(serviceGroup => serviceGroup.name.length > 1)
                .map(serviceCategory => (
                  <HeaderServiceButton
                    category={serviceCategory.name}
                    key={serviceCategory.name}
                    onCategoryClick={handleCategoryClick}
                  />
                ))}
            </Inline>
          </ScrollView>
        </Inline>
      </Box>
    </Box>
  );
};

export default StickyServiceGroupTiles;
